// Apply colors from src/portfolio.js (generated from /content/site.json)
// Usage (recommended):
//   import { theme } from "./portfolio";
//   import { applyTheme } from "./utils/applyTheme";
//   applyTheme(theme);

export function applyTheme(theme) {
  if (!theme || typeof document === "undefined") return;

  const root = document.documentElement;

  // Base palette (back-compat)
  const baseMap = {
    "--accent": theme.accent,
    "--accent2": theme.accent2,
    "--bg": theme.bg,
    "--panel": theme.panel,
    "--text": theme.text,
    "--muted": theme.muted,
    "--border": theme.border,
  };

  Object.entries(baseMap).forEach(([k, v]) => {
    if (typeof v === "string" && v.trim().length) root.style.setProperty(k, v.trim());
  });

  // Extended theme tokens
  // We flatten theme.tokens into CSS variables like:
  //   tokens.buttons.primaryBg -> --sh-buttons-primary-bg
  const tokens = theme.tokens && typeof theme.tokens === "object" ? theme.tokens : null;

  const toKebab = (s) =>
    String(s)
      .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
      .replace(/[_\s]+/g, "-")
      .toLowerCase();

  const setVar = (name, value) => {
    if (typeof value !== "string") return;
    const v = value.trim();
    if (!v) return;
    root.style.setProperty(name, v);
  };

  const walk = (obj, pathParts = []) => {
    if (!obj || typeof obj !== "object") return;
    Object.keys(obj).forEach((key) => {
      const val = obj[key];
      const next = [...pathParts, toKebab(key)];
      if (val && typeof val === "object" && !Array.isArray(val)) {
        walk(val, next);
      } else {
        setVar(`--sh-${next.join("-")}`, val);
      }
    });
  };

  if (tokens) walk(tokens);

  // Optional: update browser UI color (mobile)
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta && theme.bg) meta.setAttribute("content", theme.bg);
}
